import styled from 'styled-components'

export const StyledCard = styled.div<{ $isHovered?: boolean }>`
  padding: 20px;
  border: 1px solid
    ${({ theme, $isHovered }) =>
      $isHovered ? theme.colors.primary : '#e6e6e6'};
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 200ms ease-out;
  min-height: 200px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    padding: 18px;
  }

  @media (hover: none) {
    &:hover {
      transform: none;
    }
  }
`

export const CardHeader = styled.div`
  margin-bottom: 12px;
`

export const GroupingInfo = styled.div``

export const GroupingName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #1a1a1a;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

export const GroupingMeta = styled.p`
  font-size: 14px;
  line-height: 1.4;
  color: #666666;
  margin: 0;
`

export const MetricsRow = styled.div`
  display: flex;
  gap: 16px;
  margin: 16px 0;
  padding: 12px 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;

  @media (max-width: 768px) {
    gap: 12px;
    flex-wrap: wrap;
  }
`

export const Metric = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #404040;
`

export const MetricIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
`

export const MetricValue = styled.span`
  font-weight: 500;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  gap: 12px;
`

export const DateText = styled.p`
  font-size: 12px;
  line-height: 1.4;
  color: #808080;
  margin: 0;
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  transition: color 150ms ease-out;
  min-height: 44px;
  border-radius: 4px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary || '#0088b8'};
    background-color: #f5f5f5;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    padding: 10px;
  }
`

export const DeleteButton = styled(ActionButton)`
  color: ${({ theme }) => theme.colors.danger};

  &:hover {
    color: #cc0000;
    background-color: #ffebee;
  }
`
